onInteractive(function () {
	var body = document.body;

	// Subtiele schaduw onder de navbar zodra er gescrold wordt.
	var header = document.querySelector('.nav-header');
	if (header) {
		var onScroll = function () {
			header.classList.toggle('is-scrolled', window.scrollY > 8);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	// Animaties overslaan tijdens CMS-bewerken en bij een reduced-motion voorkeur,
	// zodat blokken daar altijd meteen zichtbaar en bewerkbaar zijn.
	var reduceMotion = window.matchMedia
		&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (
		body.hasAttribute('data-editor-mode')
		|| reduceMotion
		|| !('IntersectionObserver' in window)
	) {
		return;
	}

	// Telt een getal op van 0 naar de eindwaarde, met behoud van een achtervoegsel (bijv. "+").
	var countUp = function (el) {
		var raw = (el.textContent || '').trim();
		var match = raw.match(/^(\d[\d.,\s]*)(.*)$/);
		if (!match) {
			return;
		}
		var target = parseInt(match[1].replace(/\D/g, ''), 10);
		var suffix = match[2] || '';
		if (!target) {
			return;
		}
		var duration = 1400;
		var startTime = null;
		var tick = function (now) {
			if (startTime === null) {
				startTime = now;
			}
			var progress = Math.min((now - startTime) / duration, 1);
			var eased = 1 - Math.pow(1 - progress, 3);
			el.textContent = Math.round(eased * target) + suffix;
			if (progress < 1) {
				requestAnimationFrame(tick);
			} else {
				el.textContent = target + suffix;
			}
		};
		requestAnimationFrame(tick);
	};

	// Cijfers in de rode statistiekenbalk laten optellen wanneer ze in beeld komen.
	var counters = document.querySelectorAll('.stats-band strong');
	if (counters.length) {
		var counterObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting && !entry.target.dataset.counted) {
					entry.target.dataset.counted = '1';
					countUp(entry.target);
					counterObserver.unobserve(entry.target);
				}
			});
		}, { threshold: 0.6 });
		Array.prototype.forEach.call(counters, function (el) {
			counterObserver.observe(el);
		});
	}

	// Fade-in bij scrollen. Alleen blokken ONDER de vouw worden verborgen, zodat er
	// nooit een flikkering ontstaat bij wat al direct zichtbaar is.
	var revealSelector = [
		'.intro .col-12',
		'.service-card',
		'.benefit',
		'.stats-band .row > div',
		'.cta-band .container',
		'.sec-text-image [class*="col-"]',
		'.sec-image-text [class*="col-"]',
		'.sec-text .container',
		'.sec-usps .usp-head',
		'.sec-usps .usp-item',
		'.sec-columns [class*="col-"]',
		'.sec-steps .steps-list li',
		'.sec-accordion .accordion-head',
		'.sec-accordion .collapsible-text',
		'.sec-cta .container'
	].join(',');

	// Bepaalt een trapsgewijze vertraging op basis van de kolom-/itempositie in een rij of grid.
	var staggerDelay = function (el) {
		var row = el.closest('.row');
		if (row) {
			var child = el;
			while (child && child.parentNode !== row) {
				child = child.parentNode;
			}
			if (child) {
				return Math.min(Array.prototype.indexOf.call(row.children, child), 6) * 80;
			}
		}
		if (el.parentNode) {
			var siblings = Array.prototype.filter.call(el.parentNode.children, function (node) {
				return node.nodeType === 1;
			});
			return Math.min(siblings.indexOf(el), 6) * 80;
		}
		return 0;
	};

	var revealObserver = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-in');
				revealObserver.unobserve(entry.target);
			}
		});
	}, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

	var belowFold = window.innerHeight * 0.9;
	Array.prototype.forEach.call(document.querySelectorAll(revealSelector), function (el) {
		if (el.getBoundingClientRect().top <= belowFold) {
			return;
		}
		el.style.transitionDelay = staggerDelay(el) + 'ms';
		el.classList.add('nc-reveal');
		revealObserver.observe(el);
	});
});
